import type { ReactNode } from 'react';

const StyledButton = ({
  children,
  onClick,
  active,
}: {
  children: ReactNode;
  onClick: () => void;
  active: boolean;
}) => (
  <button
    className={`p-2 rounded-md mr-2 border transition ${
      active ? 'bg-primaryLight border-primary' : 'border-transparent'
    }`}
    onClick={onClick}
  >
    <span className="text-medium">{children}</span>
  </button>
);

export const SalaryFormatSwitch = ({
  setTimeFrameMode,
  timeFrameMode,
}: {
  setTimeFrameMode: (value: 'annual' | 'monthly') => void;
  timeFrameMode: string;
}) => {
  return (
    <div className="flex items-center flex-wrap">
      <div className="mb-2">
        <StyledButton
          onClick={() => setTimeFrameMode('annual')}
          active={timeFrameMode === 'annual'}
        >
          Annual
        </StyledButton>
        <StyledButton
          onClick={() => setTimeFrameMode('monthly')}
          active={timeFrameMode === 'monthly'}
        >
          Monthly
        </StyledButton>
      </div>
    </div>
  );
};
